import { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import sortDataByDate from "../../../../../functions/sorting/sortDataByDate";
import CylinderDetails from "./CylinderDetails";
import JobCardTable from "./JobCardTable";
// import JobCardViewDialog from "./JobCardViewDialog";
import JobCardViewDialog from "../../../dialogs/JobCardViewDialog/JobCardViewDialog";

const JobCardResults = () => {
  const [selectedJobCard, setSelectedJobCard] = useState(null);

  const data = useSelector((state) => state.data.data);

  const sortedData = useMemo(() => {
    return sortDataByDate(data, "startedAt");
  }, [data]);

  return (
    <div className="p-3 bg-white border-1 border-dBlue-100 rounded-lg mt-1 h-[calc(100vh-11em)] lg:h-[calc(100vh-13em)]">
      <h3 className="text-sm lg:text-lg text-dark-blue font-figtreeMedium">
        Job Card History Results
      </h3>

      <div className="flex gap-2 mt-2">
        <JobCardTable data={sortedData} onView={setSelectedJobCard} />
        <CylinderDetails data={data[0]} />
      </div>

      {selectedJobCard && (
        <JobCardViewDialog
          data={selectedJobCard}
          closeDialog={() => setSelectedJobCard(null)}
        />
      )}
    </div>
  );
};

export default JobCardResults;
